window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }

});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '£{{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();
    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }
 
    
  
  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
     
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },
   
    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });
      
           
     


      return found || null;
    },
 

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();
if (variant) {
  var form = jQuery(".single-option-selector").closest('form');
  for (var i=0,length=variant.options.length; i<length; i++) {
    var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] +'"]');
    if (radioButton.size()) {
      radioButton.get(0).checked = true;
    }
  }
}
      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }


      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },


    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
    
  });
 
  return Variants;
})();

theme.ExitIntent = (function() {

    if (window.location.pathname == '/challenge' || window.location.pathname == '/contact' ){
      return false;
    } 

    // Seceltors 
    var selectors = {
        modalActive        : false,
        $modal             : $('#modal'),
        $modalClose        : $('.modal__close-link, .modal__close'),
        modalOpenClass     : 'modal--open',
        cookieName         : '__exit-intent',
        cookieExpire       : 7,
        cookieExpireSignup : 300,
        _delayTimer        : null,
        delayFunction      : $('#modal').attr('data-exit-intent_delay') * 1000 || 0,
        delay              : $('#modal').attr('data-exit-intent_popup_delay') * 1000 || 0,
        _html              : document.documentElement
    };


    function init() {
        contactSubmitted();
        setTimeout(exitIntent, selectors.delayFunction);
    };

    init();

    function exitIntent() {
        if (isDisabled()) { return; }
        selectors._html.addEventListener('mouseleave', handleMouseleave);
        selectors._html.addEventListener('mouseenter', handleMouseenter);
        selectors._html.addEventListener('keydown', handleKeydown);
        selectors.$modalClose.on('click', modalClose);
    }

    function handleMouseleave(e) {
        if (e.clientY > selectors.sensitivity) { return; }
        selectors._delayTimer = setTimeout(modalOpen, selectors.delay);
    }

    function handleMouseenter() {
        if (selectors._delayTimer) {
          clearTimeout(selectors._delayTimer);
          selectors._delayTimer = null;
        }
      }

    function handleKeydown(e) {
        if (e.keyCode === 27) { modalClose() }
    }

    function isDisabled() {
        return $.cookie(selectors.cookieName);
    }

    function modalClose() {
        selectors.modalActive = false;
        selectors.$modal.hide();
        $.cookie(selectors.cookieName, 'true', { expires: selectors.cookieExpire, path: '/' });
    }

    function modalOpen(container) {
        selectors.modalActive = true;
        selectors.$modal.show();
    }

    // URL Contains /?customer_posted=true
    function contactSubmitted(){
        var name = 'customer_posted'
        var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
        if (results==null){
          var results = 'false';
        } else {
          var results = results[1] || 0;
        }
        if (results == 'true'){
          $.cookie(selectors.cookieName, 'true', { expires: selectors.cookieExpireSignup, path: '/' });
        } 
    }


})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    productSliderVariant: '[data-slick-variant]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);
    this.$sliderImage = $(selectors.productSliderVariant);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);
      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    } else if (this.$sliderImage.length > 0) {
      this.$container.on('variantImageChange' + this.namespace, this.updateProductSlider.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        //$(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
      this.$featuredImage.attr('src', sizedImgUrl);
    },

    updateProductSlider: function(evt) {
      var variant = evt.variant.id;
      this.$sliderImage = $(selectors.productSliderVariant);

      this.$sliderImage.each(function (index, value) { 
        var slickSlide = $(this).attr('data-slick-variant');
        var slickVar   = parseInt(slickSlide);
        if (slickVar == variant) {
          var slideNo = $(this).attr('data-slick-index');
          $('.main-product-slider').slick('slickGoTo', slideNo);
        }
      });
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

theme.Navigation = (function() {

  var $hamburger        = $('#Hamburger'),
      $menuClose        = $('#Close-nav'),
      $Header           = $('#Header'),
      $mobileOverlay    = $('.mobile-overlay'),
      $mobileHeader     = $('.mobile-header'),
      $navigation       = $('.site-nav__logo-link, .site-nav, .close-nav'),
      body = document.querySelector('.body'),
      slideOut = new Hammer(body);

  $hamburger.on('click', navigationOpen);
  $menuClose.on('click', navigationClose);

  $(document).on('mouseup', function(event){
    if ($('body').hasClass('js--mobile-menu-open')) {
      if (!$navigation.is(event.target) && $navigation.has(event.target).length === 0){ 
        navigationClose();
      }
    }
  });

	// slideOut.on("swipeleft swiperight", mobileNavigationSlideGesture);

  function navigationClose() {
    $('body').removeClass('js--mobile-menu-open')
  };

  function navigationOpen() {
    $('body').addClass('js--mobile-menu-open')
  };

  // function mobileNavigationSlideGesture(ev) {
		// var $target = $(ev.target);
		// // if (target) {}
		// if (!$target.parents('.slick-slider').length) {
		// 	if (ev.type == "swiperight") {
		// 		$('body').addClass('js--mobile-menu-open')
		// 	}else if(ev.type == "swipeleft") {
		// 		$('body').removeClass('js--mobile-menu-open')
		// 	}
		// }
  // }
  
})();

slate.convertEmojis = (function() {

	
})();
theme.Meganav = (function() {

  var $siteNavList = $('.site-nav li'),
     $siteDropdown = $('.meganav'),
     openClass = 'site-nav__submenu--open';

  $siteNavList.on('mouseenter', showMeganav);

  $siteDropdown.on('mouseleave mousedown', function(e) {
    if( e.type != 'mousedown' && e.originalEvent.buttons != 2 ){
      $siteDropdown.removeClass('meganav--show');
    }
  });

  function showMeganav(){
    
      var $this         = $(this),
          $parentId     = $this.data('meganav-parent');

      $siteDropdown.removeClass('meganav--show');

      $siteDropdown.each(function(){
        var $childId = $(this).data('meganav-child');

        if( $parentId == $childId ){
            $(this).addClass('meganav--show');
        }
      });
  }

  function positionArrow(){
    $('.site-nav li[data-meganav-parent]').each(function(){
      var $thisMatch = $(this).data('meganav-parent'),
          $thisWidth = $(this).find("a").innerWidth(),
          $thisPos = $(this).offset().left,
          $newWidth = $thisWidth/2 + $thisPos -15;
      $(".meganav[data-meganav-child='"+$thisMatch+"']").find(".meganav__arrow").css("transform","translateX("+$newWidth+"px)");
    });
  }

  function dupicateNav(){
    $('.meganav').each(function(){
      var $thisList = $(this).find(".meganav__list").html(),
        $thisMatch = $(this).data('meganav-child'),
        $thisColor = $(this).attr("style");

      $(".site-nav li[data-meganav-parent='"+$thisMatch+"']").addClass("site-nav--has-submenu").append("<div class='medium-up--hide site-nav__submenu' style='"+$thisColor+"'>"+$thisList+"</div>");
    });
  }

  $(".dropdown-open").on("click",function(){
    $(".site-nav li").removeClass(openClass);
    $(this).parent().parent().toggleClass(openClass);
    return false;
  });
  $(".dropdown-close").on("click",function(){
    $(".site-nav li").removeClass(openClass);
    return false;
  })

  positionArrow();
  dupicateNav();
  $(window).resize(function(){
    positionArrow();
  })

})();


theme.MeganavSection = function MeganavSection() {};

theme.MeganavSection.prototype = $.extend({}, theme.MeganavSection.prototype, {
  onBlockSelect: function(e){
    var blockId     = e.detail.blockId;
    $('#Meganav-' + blockId).addClass('meganav--show');
  },
  onBlockDeselect: function() {
    $('.meganav').removeClass('meganav--show');
  }
});
theme.StickNav = (function() {

	var activeClass = 'header-fixed--active',
		$header     = $('.header-fixed') || null;

  	$(window).on('scroll', stickyNavigation);

  	function stickyNavigation() {
  		if ($header.length > 0) {
			var scrollTop        = $(window).scrollTop(),
				headerOffestTop = $header.offset().top;

			if( scrollTop > headerOffestTop ){
				$header.addClass(activeClass);
			} else {
				$header.removeClass(activeClass);
			}
		}
 	}

  return stickyNavigation;

})();



theme.Newsletter = (function() {

	// URL Contains /?customer_posted=true
  function contactSubmitted(){
        
      var name = 'customer_posted'
      var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
      if (results==null){
        var results = 'false';
      } else {
        var results = results[1] || 0;
      }
      if (results == 'true'){
        removeHash();
		  	window.onbeforeunload = function () {
				  window.scrollTo(0, 10000);
				}
				slide('#Footer')
      } 


  }



	  if(document.URL.indexOf("challenge") >= 0){ 
	  	removeHash();
	  	window.onbeforeunload = function () {
			  window.scrollTo(0, 0);
			}
		}



		function removeHash () { 
			history.pushState("", document.title, window.location.pathname + window.location.search);
		}
  
		function scrollTop () { 	
			console.log('scroll');  	
	  	document.body.scrollTop = 0;
	    document.documentElement.scrollTop = 0;
	  }




  function slide(elm){
    $("html, body").animate({
      scrollTop: $(elm).offset().top
    }, 0)
  }





  contactSubmitted();

})();
/* ================= Search Popup ================= */
theme.SearchPopup = (function() {

  if($(".site-header__search-icon.full-screen-search").length != 0){
    $(document).on('keydown', function(evt) {
      if (evt.keyCode === 27) {
        $('body > .search-hero').removeClass('search-hero--is-active');  
      }
    });
    $('.search-hero__close').on('click', function(e) {
      $('body > .search-hero').removeClass('search-hero--is-active');
    });
    $('.site-header__search-icon').on('click', function(e) {
      $('body > .search-hero').addClass('search-hero--is-active');
      $( ".search-hero__inner .search__input" ).focus();
      return false;
    });
  }else{
    var $searchForm  = $('.site-header__search-icon');
        $searchFocus = $('.search-form .search-input');
    $searchForm.on('click', function(e) {
      var $this = $(this);
      $this.addClass('search-form--is-active');
      $('.search-form .search-input').focus();

      return false;
    });

    $searchFocus.focusout(function(){
      $searchForm.removeClass('search-form--is-active');
    })

    // $('.search-hero__close').on('click', function(e) {
    //   $('header .search-hero').removeClass('search-small--is-active');
    // });
  }


})();

theme.Slideshow = (function() {

	var $slideshow = $('.slideshow');

  function slickRender(){
  	$slideshow.slick(getSliderSettings());
  }

  function getSliderSettings(){
	  return {
	    slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			fade: true,
			dots:true,
			loop: true,
			autoplay: true,
		  autoplaySpeed: 2000
	  }
	}

  function videoSlide(){
    $(".slideshow__slide").each(function(){
      if($(this).find(".slideshow__video").length != 0){
        //video in this slide

        var $thisSlide = $(this),
            $thisVideo = $(this).find(".slideshow__video"),
            $thisid = $thisVideo.attr("id"),
            $thisurl = $thisVideo.attr("data-video-url"),
            $thisvidid = $thisVideo.attr('data-id'),
            $thistype = $thisVideo.attr('data-type');
        $thisbgvideo = $('.background-video');
        if($thisurl == "youtube"){
          var vid = '<iframe src="//www.youtube.com/embed/' + $thisvidid + '?controls=1" width="560" height="315" frameborder="0" allowfullscreen></iframe>';
        }else{
          var vid = '<iframe src="//player.vimeo.com/video/' + $thisvidid + '" width="560" height="315" frameborder="0" allowfullscreen></iframe>';
        }

        if($thisbgvideo.length > 0 ){
          if($thisurl == "youtube"){
            var bgvid = '<iframe src="//www.youtube.com/embed/' + $thisvidid + '?autoplay=1&controls=0&mute=1" width="' + $(window).width() + '" height="' + $(window).width()/16*9 + '" frameborder="0" allowfullscreen autoplay></iframe>';
          }else{
            var bgvid = '<iframe src="//player.vimeo.com/video/' + $thisvidid + '?autoplay=1&controls=0&mute=1" width="560" height="315" frameborder="0" allowfullscreen> autoplay</iframe>';
          }

          $thisbgvideo.html(bgvid);
        }

        $thisVideo.html(vid);

        $(this).find(".slideshow__video-control--play").on("click",function(){
          $thisSlide.addClass("video-is-playing");
          return false;
        })

        $(this).find(".slideshow__video-control--close").on("click",function(){
          $thisSlide.removeClass("video-is-playing");
          return false;
        });

      }
    });
  }

  function init(){
    slickRender();
    videoSlide();
  }

  init();

  return {
    sliderSettings: getSliderSettings
  }

})();

theme.SlideshowSection = function SlideshowSection() {};

theme.SlideshowSection.prototype = $.extend({}, theme.SlideshowSection.prototype, {
	onBlockSelect: function(e){
		var blockId     = parseInt(e.detail.blockId),
		    $blockClass = $('.slideshow__slide--' + blockId),
		    slideIndex  = $blockClass.attr('data-slick-index');
		$('.slideshow').slick("goTo", slideIndex);
	},
  onSelect: function() {
	  $('.slideshow').slick(theme.Slideshow.sliderSettings());
  }
});
theme.Testimonials = (function() {

	$('.quotes-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
        autoplaySpeed: 2000,
		fade: true,
		dots:true,
      autoplay:true
	});

})();
theme.CollectionSlider = (function() {

	$('.collection-carousel').slick({
		arrows:true,
		vertical:false,
		prevArrow: '<div class="slick-arrow slick-prev"> < </div>',
		nextArrow: '<div class="slick-arrow slick-next"> > </div>',
	  	responsive: [
		    {
		      breakpoint: 1024,
		      settings: {
		        slidesToShow: 3,
		        slidesToScroll: 3,
		        infinite: true,
		        dots: true
		      }
		    },
		    {
		      breakpoint: 600,
		      settings: {
		        slidesToShow: 2,
		        slidesToScroll: 2
		      }
		    },
		    {
		      breakpoint: 480,
		      settings: {
		        slidesToShow: 1,
		        slidesToScroll: 1
		      }
		    }
	  	]
	});

})();
theme.Collection = (function() {

  $('.collection-grid-item__match-height').matchHeight();
  $('.description-section__match-height').matchHeight();

  $('.product-meta__left').matchHeight();

  $('.half-hero-menu__option').click(function(){
    if( $(this).data('action') == 'show-hero' ){
      $('.hero-main--center .copy-main__wrapper').toggleClass('show-hero');
    } else {
      $('html, body').animate({
        scrollTop: ($('#shopify-section-landing--product-list').offset().top)
      },500);
    }
  });
  
  
})();



theme.ProductSlider = (function() {

	$('.main-product-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		fade: true,
		dots: true
	});

	// $('.product-slider-nav').slick({
	// 	slidesToShow: 3,
	// 	slidesToScroll: 1,
	// 	asNavFor: '.main-product-slider',
	// 	dots: true,
	// 	arrows:true,
	// 	centerMode: true,
	// 	focusOnSelect: true,
	// 	vertical:false,
 //    verticalSwiping: false
	// });
})();



theme.Swatch = (function() {

	var $swatch = $('.swatch-product');

  	$swatch.on('click', swatchChange);

  	function swatchChange() {
  		var $this       = $(this),
			swatchValue = $this.attr('data-swatch-value');

			$('.selector-wrapper--colour select').val(swatchValue).trigger('change');

 	}

})();



theme.Accordion = (function() {

	var $title      = $(".accordion__title"),
		$content    = $('.accordion__content'),
		activeClass = 'accordion__content--is-active',
		activeClassParent = 'accordion__item--is-active';
	

	$title.bind('click', accordionOpen);

	function accordionOpen(){
		var $this = $(this);
			toggleData = $this.attr('data-toggle');

		$content.removeClass(activeClass);
		$content.parent().removeClass(activeClassParent);
		$('#'+toggleData).addClass(activeClass);
		$('#'+toggleData).parent().addClass(activeClassParent);
	}

})();



theme.NotificationBar = (function() {

	var $notificationBar = $('.notification-bar--carousel');

	$notificationBar.slick(getSliderSettings());

  function getSliderSettings(){
	  return {
	    arrows:true,
			vertical:false,
			slidesToShow: 1,
			slidesToScroll: 1,
			prevArrow: '<div class="slick-arrow slick-prev"></div>',
			nextArrow: '<div class="slick-arrow slick-next"></div>',
	  }
	}

	return {
		sliderSettings: getSliderSettings
	}

})();

theme.NotificationBarSection = function NotificationBarSection() {};

theme.NotificationBarSection.prototype = $.extend({}, theme.NotificationBarSection.prototype, {
	onBlockSelect: function(e){
		var blockId     = parseInt(e.detail.blockId),
		    $blockClass = $('.notification-bar-' + blockId),
		    slideIndex  = $blockClass.attr('data-slick-index');
		$('.notification-bar--carousel').slick("goTo", slideIndex);
	},
  onSelect: function() {
	  $('.notification-bar--carousel').slick(theme.NotificationBar.sliderSettings());
  }
});
theme.InstagramFeed = (function() {
	
	if($("#instafeed").length != 0){

			 var myuserid = $("#instafeed").attr("data-user-id"),
			 myaccesstoken = $("#instafeed").attr("data-access-token"),
				//var myuserid = '3648857540',
				//myaccesstoken = '3648857540.1677ed0.71a1ca1bec6d4978be929c1386c46561',
				userFeed = new Instafeed({
	        get: 'user',
	        userId: myuserid, //Put The user id here..
	        accessToken: myaccesstoken, //Put The access token here..
	        resolution:'standard_resolution',
	        limit: '6',
	      	template: '<div class="grid__item small--one-half medium--one-half large-up--one-third"><a class="insta_img"  target="_blank" href="\{\{link\}\}"><img data-src="\{\{image\}\}" class="lazyload insta_img__image" ><span class="inner"><span class="inner-text">{{caption}}</span></span></a></div>'
		    }); 
		    userFeed.run();

	}
})();
theme.AjaxCart = (function() {

  if (theme.ajaxCart == false) {
    return false;
  }

  var selectors = {
    $form            : $('form[action="/cart/add"]:not(.subb)'),
    $cartCount       : $('#CartCount, .cart-ajax__subtitle-counter'),
    $cartList        : $('.cart-ajax__list'),
    $cartBody        : $('.cart-ajax__wrapper'),
    $cartTotalPrice  : $('.cart-ajax--total-price'),
    $cartClose       : $('.cart-ajax__close'),
    $cartCloseButton       : $('.cart-ajax__close_button'),
	  $cartToggleBtn   : $('#Cart-icon')
  };

  var storeCurrency = 'amount',
			cartOpened = false,
     	cartPage   = window.location.pathname,
      cartCheck  = true;

  /* ----------------------------------------------------
  Add to cart functions
  -----------------------------------------------------*/ 
  selectors.$form.on('submit', function(event){
    event.preventDefault ? event.preventDefault() : (event.returnValue = false);

    var $this         = $(this);

//     if ($this.attr("data-sub") == "no-sub") {
//       $('.rc_label__onetime').trigger('click');
//     }

    var formData      =  selectors.$form.serializeArray()

    // getCartJSON(multipleOfThree, formData, $error);
    addToCart(formData);
  });

  /* ----------------------------------------------------
  change cart functions and triggers
  -----------------------------------------------------*/ 
  $(document).on('click', '.cart-ajax__remove', function(event){
    var $this     = $(this);
    cartValueTrigger($this, 'remove');
  });

  $(document).on('focusout', '.cart-ajax .quantity-wrapper input', function(event){
    var $this = $(this);
    cartValueTrigger($this);
  });

  $(document).on('click', '.cart-ajax .quantity-wrapper', function(event){
    var $this = $(this);
    cartValueTrigger($this);
  });

  function cartValueTrigger(element, remove){
    var $this        = element,
        variantId    = $this.closest('.cart-data').attr('data-id'),
        lineNo       = $this.closest('.cart-data').attr('data-line'),
        input        = $this.parent().find('input'),
        sendQuantity = parseInt(input.val());

        if (remove == 'remove'){
          var sendQuantity = 0;
        }

    changeCart(lineNo, sendQuantity, variantId);
  }

  /* ----------------------------------------------------
  Cart open and close functions
  -----------------------------------------------------*/
  selectors.$cartToggleBtn.on('click', function(event){
    event.preventDefault ? event.preventDefault() : (event.returnValue = false);
    cartRender();
  });

  $(document).on('mouseup', function(event){
    if (!selectors.$cartBody.is(event.target) && selectors.$cartBody.has(event.target).length === 0){ 
      cartClose();
    }
  });

  selectors.$cartClose.on('click', function(){
  	cartClose();
  });
  
  selectors.$cartCloseButton.on('click', function(){
  	cartClose();
  });
  

      
  jQuery(document).on('cart.requestComplete', function(event, cart) {
    cartRender();
  });

  /* ----------------------------------------------------
  Below are all the functions for Add to cart, update cart and get cart data
  -----------------------------------------------------*/

  function addToCart(formData){
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: formData,
      dataType: 'json',
      success: function(response){ 
        cartRender();

      }
    })
  }

  function changeCart(lineNo, quantity, variantId){
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=' + quantity + '&line=' + lineNo,
      dataType: 'json',
      beforeSend: function(response){
        // if( quantity == 0 && cartPage === '/cart') {
        //   $('.cart__row--' + variantId).fadeOut().remove();
        // }
      },
      success: function(response){ 
        cartRender();
      }
    })
  }
 
  function getCartJSON(callback, x, y) {
    jQuery.getJSON('/cart.js', function (cart) {
      callback(cart, x, y);
    });
  };

  /* ----------------------------------------------------
  Below are all the functions update the cart display - Ajax and cart page
  -----------------------------------------------------*/
  function cartRender() {
    if (cartPage === '/cart') {
      // getCartJSON(updateCartTotal);
      // getCartJSON(updateLineItems);
    } else  {
      getCartJSON(cartBuild);
      if( cartOpened != true ){ 
        cartOpen();
      }
    }
    getCartJSON(cartCounter);
  };


  // Ajax Cart Open
  function cartOpen() {
    selectors.$cartBody.addClass('cart-ajax--show');
    cartOpened = true;
    $("html, body").animate({ scrollTop: 0 }, "200");
  };

  // Ajax Cart Close
  function cartClose(){
    selectors.$cartBody.removeClass('cart-ajax--show');
    cartOpened = false;
  }

  function cartCounter(cart) {
    selectors.$cartCount.html(cart.item_count);
    if (cart.item_count != 0){
      selectors.$cartCount.addClass('cart-count--show');
    } else{
      selectors.$cartCount.removeClass('cart-count--show');
    }
  };

  function cartBuild(cart) {

    items     = cart.items,
    cartTotal = slate.Currency.formatMoney(cart.total_price);

    selectors.$cartList.html('');
    selectors.$cartTotalPrice.html('<span class=money>'+cartTotal+'</span>');

    $.each(items, function(i, item){

      var cartRow = createMarkup(item, i);
      selectors.$cartList.append(cartRow);

    });

    relateProducts(cart);

  };

  function createMarkup(cart, loopCount) {

    var cartVariantTitle = cart.variant_title != null ? cart.variant_title : '' ,
        cartVariantPrice = slate.Currency.formatMoney(cart.price),
        cartLinePrice    = slate.Currency.formatMoney(cart.line_price),
        loopCounter      = loopCount + 1,
        url              = cart.url;

        if(cart.product_type == "Subscription"){ 
          var url = "/pages/subscriptions";
        } 


    var cartRow = '<div class="cart-ajax__row cart-data" data-line="' + loopCounter + '" data-id="' + cart.id + '"><div class="cart-ajax__row__column"><a href="' + url + '" class="js-click-gtm cart-ajax__row__image" style="background-image: url(' + cart.image + ')"></a></div><div class="cart-ajax__row__column"><a href="' + url + '" class="js-click-gtm h6 cart-ajax__row__title">' + cart.product_title + '<span> </span><small class="cart-ajax__row__variant">' + cartVariantTitle + '</small> </a> <span class="cart-ajax__row__money"' + cartLinePrice + '</span><span class="cart-ajax__row__unit-price">' + cartVariantPrice + '</span><div class="quantity-wrapper"><div class="quantity-wrapper__minus js--quantity" data-increment="false">-</div><input type="number" value="' + cart.quantity + '" min="0"><div class="quantity-wrapper__plus js--quantity" data-increment="true">+</div></div><div class="cart-ajax__remove">X</div></div></div>';

    return cartRow;
	}


  function relateProducts(cart){

    if ($(window).width() < 750) {
      return false
    }
    var relateProducts = [],
        counter        = 0;       
    $.each(cartUpsell, function(i, item){

      var collectionItem    = item,
          collectionItemVar = collectionItem.variants[0].id,
          relateBoo         = false;

      $.each(cart.items, function(i, cartItem){
        if (cartItem.id == collectionItemVar ){
          relateBoo = true;
        }
      });

      if (relateBoo == false){
        counter = counter + 1;
        var relatedProductImage = '<div class="cart-ajax__related__product-image" style="background-image:url(' + collectionItem.featured_image+ ')"></div>',
            relatedProductTitle = '<h5 class="cart-ajax__related__product-title">'+ collectionItem.title +'</h5><p class="cart-ajax__related__product-price">'+ slate.Currency.formatMoney(collectionItem.price) +'</p>',
            relatedProduct      = '<a href="/products/' + collectionItem.handle + '" class="cart-ajax__related__product-wrapper">' + relatedProductImage + relatedProductTitle + '</a>';

        relateProducts.push(relatedProduct);
      }
    });
    if(relateProducts.length == 0){
      $('.cart-ajax__related-title').addClass('cart-ajax__related-title--hide');
    } else {
      $('.cart-ajax__related-title').removeClass('cart-ajax__related-title--hide');
    }

    $('.cart-ajax__related').html(relateProducts);
  }

  // Cart Page
  function updateCartTotal(cart){
    // selectors.$subTotalClass.html( moneyFormatter.format(storeCurrency, (cart.total_price/100)) );
    // selectors.$cartItems.html(cart.item_count);
  }

  function updateLineItems(cartdata){
    // $.each(cartdata.items, function(i, item){

    //   var linePrice    = moneyFormatter.format(storeCurrency, (item.original_line_price/100)),
    //       lineQuantity = item.quantity,
    //       newLineData  = i + 1;

    //     $('.cart__row--' + item.id + ' .cart__line-total').html(linePrice)
    //     $('.cart__row--' + item.id + ' .cart-ajax__quantity__input').val(lineQuantity)
    //     $('.cart__row--' + item.id + ' .cart-data').attr('data-line', newLineData);
    // });
  }



  function getFormData($form){
    var unindexed_array = $form;
    var indexed_array = {};

    $.map(unindexed_array, function(n, i){
        indexed_array[n['name']] = n['value'];
    });

    return indexed_array;
  }

  return {
    addToCart: addToCart
  };
 
})();
theme.Quantity = (function() {

    $(document).on('click', '.js--quantity', function(e){
      e.preventDefault();
      var $input       = $(this).parent().find('input'),
          inputVal     = parseInt($input.val()),
          sendQuantity = 0,
          incrementBoo = $(this).attr('data-increment'),
          increment    = incrementBoo.toString();

      if( increment == 'true' ){
        var newVal = inputVal+1;
        $input.val(newVal);
      } else {
        if(inputVal-1 != 0){
          var newVal = inputVal-1;
          $input.val(newVal);
        }
      }
    });

})();
theme.Video = (function() {

  
})();
theme.SizeGuide =  new function(){

  var selectors = {
    $sizeGuideTrigger  : $('.js--size-guide'),
    $sizeGuideClose    : $('.size-guide__close, .size-guide__background'),
    $sizeGuidePanel    : $('.size-guide__wrapper'),
    activeClass        : 'size-guide--show',
    $mesurementsToggle : $('.size-guide__toggle')
  };

  selectors.$sizeGuideTrigger.on('click', function(event){
    event.preventDefault ? event.preventDefault() : (event.returnValue = false);
    openSizeGuide();
  });

  selectors.$sizeGuideClose.on('click', function(event){
    event.preventDefault ? event.preventDefault() : (event.returnValue = false);
    closeSizeGuide();
  });

  selectors.$mesurementsToggle.on('click', function(event){
    event.preventDefault ? event.preventDefault() : (event.returnValue = false);
    mesurementsToggle($(this));
  });

  openSizeGuide = function(){
    selectors.$sizeGuidePanel.addClass(selectors.activeClass);
  }

  closeSizeGuide = function(){
    selectors.$sizeGuidePanel.removeClass(selectors.activeClass);
  }

  mesurementsToggle = function(x){
    var $this = x,
        size = $this.attr('data-size');

    selectors.$mesurementsToggle.removeClass('active');
    $this.addClass('active');

    $('.size-guide__measurement').hide();
    $('.' + size).show();
  }

  this.onSectionLoad = function(target){
  }
}();  
theme.Blog = (function() {
  $('.blog-grid-item__meta').matchHeight();
  $('.recipe-item__match-height').matchHeight();
  $('.quote-block__section-match-height').matchHeight();

  if ($(window).width() > 749) {
    $('.instagram .blog-grid-item__container').matchHeight({
      target: $('#rap__med__instagram')
    });
  }

})();
theme.Twitter = (function() {
  var $TwitterFeed = $('#TwitterFeed');

  if (!$TwitterFeed.length) {
    return false;
  }

  var userName = $TwitterFeed.attr('data-username'),
      retweets = JSON.parse($TwitterFeed.attr('data-retweets')),
      images = JSON.parse($TwitterFeed.attr('data-images'));

  var configProfile = {
    "profile": {"screenName": userName },
    "domId": 'TwitterFeed',
    "maxTweets": 3,
    "enableLinks": true, 
    "showUser": true,
    "showTime": true,
    'showInteraction': false,
    "showImages": images,
    'showRetweet': retweets,
    "lang": 'en'
  };
  twitterFetcher.fetch(configProfile);
})();
theme.Subscription = (function() {

  // $('.subsciption__product').matchHeight(); 
  $('.subsciption__product__title__wrapper').matchHeight(); 
  $('#subscription__choice .subsciption__product__text').matchHeight({byRow:false}); 
  $('#subscription__house-block .subsciption__product__text').matchHeight({byRow:false}); 

  var selectors = {
    $submit           : $('#Subscription__submit'),
    $product          : $('.subsciption__product'),
    $quantity         : $('.subsciption__quantity'),
    $interval         : $('#Subsciption__interval'),
    $price            : $('#Subscription-price'),
    $houseBlockTrigger: $('.subsciption__product--open-house'),
    $houseBlockClose  : $('.subsciption__product--close-house'),
    $houseBlock       : $('.subsciption__product-list--house-block'),
    
    $wholebeanBlockTrigger: $('.subsciption__product--open-wholebean'),
    $wholebeanBlockClose  : $('.subsciption__product--close-wholebean'),
    $wholebeanBlock       : $('.subsciption__product-list--wholebean-block'),
    
    $haloFavsBlockTrigger: $('.subsciption__product--open-halo-favs'),
    $haloFavsBlockClose  : $('.subsciption__product--close-halo-favs'),
    $haloFavsBlock       : $('.subsciption__product-list--halo-favs-block'),
    
    $curatedBlockTrigger: $('.subsciption__product--open-curated'),
    $curatedBlockClose  : $('.subsciption__product--close-curated'),
    $curatedBlock       : $('.subsciption__product-list--curated-block'),
    
    $exoticBlockTrigger: $('.subsciption__product--open-exotic'),
    $exoticBlockClose  : $('.subsciption__product--close-exotic'),
    $exoticBlock       : $('.subsciption__product-list--exotic-block'),

    activeClass       : 'subsciption__product--active',
    productId         : $('.subsciption__product--active').attr('data-subscription-id'),
    quantity          : $('#Subsciption__quantity').attr('data-subscription-quantity'),
    interval          : $('#Subsciption__interval').attr('data-subscription-interval'),
    subId             : $('.subsciption__product--active').attr('data-subscription-sub-id'),

    $productMirror    : $('.subsciption__product__mirror'),
    $quantityMirror   : $('.subsciption__qunatity__mirror'),
    $intervalMirror   : $('.subsciption__interval__mirror'),
    $error            : $('.subscription__error')
  };




  /* ----------------------------------------------------
  Add to cart functions
  -----------------------------------------------------*/ 
  selectors.$submit.on('click', function(event){
    event.preventDefault ? event.preventDefault() : (event.returnValue = false);    
    subscriptionValidate();
  })


  /* ----------------------------------------------------
  open/close house function
  -----------------------------------------------------*/
  selectors.$houseBlockTrigger.on('click',function(event){
    selectors.$houseBlock.addClass('subsciption__product-list--house-block-active');
    $('.subscription_product_container').each(function(){
      $(this).addClass('subscription_product_container--hidden');
      $('#Subscription__submit').attr('data-order-form', 'true');
      
      $('.subscription__summary').addClass('subscription__summary--hidden');
      $('.subscription__summary_extra').addClass('subscription__summary--hidden');
      //$('.subsciption__interval-inline').addClass('subscription__summary--hidden');
      slide('#subscription__house-block');

    });
    
  })

  selectors.$houseBlockClose.on('click',function(event){
    selectors.$houseBlock.removeClass('subsciption__product-list--house-block-active');
    var productSubscription = $(this).data('product');
    $('.subscription_product_container').each(function(){
      $(this).addClass('subscription_product_container--hidden');
      if(productSubscription == $(this).data('product') ){
      	$(this).removeClass('subscription_product_container--hidden');
        $(this).find('#Subscription__submit').attr('data-order-form', 'false');
        $('.subscription__summary').removeClass('subscription__summary--hidden');
        $('.subscription__summary_extra').removeClass('subscription__summary--hidden');
        //$(this).find('.subsciption__interval-inline').removeClass('subscription__summary--hidden');
        $("html, body").animate({
          scrollTop: $(this).find('.subsciption__interval_first').offset().top - 80
        }, 500);
      }
    });
  })
  //$('.subsciption_product_container')
  
  /* ----------------------------------------------------
  open/close wholebean function
  -----------------------------------------------------*/
  selectors.$wholebeanBlockTrigger.on('click',function(event){
    selectors.$wholebeanBlock.addClass('subsciption__product-list--wholebean-block-active');
    $('.subscription_product_container').each(function(){
      $(this).addClass('subscription_product_container--hidden');
      $('#Subscription__submit').attr('data-order-form', 'true');
      $('.subscription__summary').addClass('subscription__summary--hidden');
      $('.subscription__summary_extra').addClass('subscription__summary--hidden');
      slide('#subscription__wholebean-block');

    });
    
  })

  selectors.$wholebeanBlockClose.on('click',function(event){
    selectors.$wholebeanBlock.removeClass('subsciption__product-list--wholebean-block-active');
    var productSubscription = $(this).data('product');
    $('.subscription_product_container').each(function(){
      $(this).addClass('subscription_product_container--hidden');
      if(productSubscription == $(this).data('product') ){
      	$(this).removeClass('subscription_product_container--hidden');
        $(this).find('#Subscription__submit').attr('data-order-form', 'false');
        $('.subscription__summary').removeClass('subscription__summary--hidden');
        $('.subscription__summary_extra').removeClass('subscription__summary--hidden');
        $("html, body").animate({
          scrollTop: $(this).find('.subsciption__interval_first').offset().top - 80
        }, 500);
      }
    });
  })
  
   /* ----------------------------------------------------
  open/close halo-fav function
  -----------------------------------------------------*/
  selectors.$haloFavsBlockTrigger.on('click',function(event){
    selectors.$haloFavsBlock.addClass('subsciption__product-list--halo-favs-block-active');
    $('.subscription_product_container').each(function(){
      $(this).addClass('subscription_product_container--hidden');
      $('#Subscription__submit').attr('data-order-form', 'true');
      
      $('.subscription__summary').addClass('subscription__summary--hidden');
      $('.subscription__summary_extra').addClass('subscription__summary--hidden');
     $('.subsciption__interval-inline').addClass('subscription__summary--hidden');
      slide('#subscription__halo-favs-block');

    });
    
  })

  selectors.$haloFavsBlockClose.on('click',function(event){
    selectors.$haloFavsBlock.removeClass('subsciption__product-list--halo-favs-block-active');
    var productSubscription = $(this).data('product');
    $('.subscription_product_container').each(function(){
      $(this).addClass('subscription_product_container--hidden');
      if(productSubscription == $(this).data('product') ){
      	$(this).removeClass('subscription_product_container--hidden');
        $(this).find('#Subscription__submit').attr('data-order-form', 'false');
        $('.subscription__summary').removeClass('subscription__summary--hidden');
        $('.subscription__summary_extra').removeClass('subscription__summary--hidden');
        $(this).find('.subsciption__interval-inline').removeClass('subscription__summary--hidden');
        $("html, body").animate({
          scrollTop: $(this).find('.subsciption__interval_first').offset().top - 80
        }, 500);
      }
    });
  })
  
  /* ----------------------------------------------------
  open/close curated function
  -----------------------------------------------------*/
  selectors.$curatedBlockTrigger.on('click',function(event){
    selectors.$curatedBlock.addClass('subsciption__product-list--curated-block-active');
    $('.subscription_product_container').each(function(){
      $(this).addClass('subscription_product_container--hidden');
      $('#Subscription__submit').attr('data-order-form', 'true');
      
      $('.subscription__summary').addClass('subscription__summary--hidden');
      $('.subscription__summary_extra').addClass('subscription__summary--hidden');
     $('.subsciption__interval-inline').addClass('subscription__summary--hidden');
      slide('#subscription__curated-block');

    });
    
  })

  selectors.$curatedBlockClose.on('click',function(event){
    selectors.$curatedBlock.removeClass('subsciption__product-list--curated-block-active');
    var productSubscription = $(this).data('product');
    $('.subscription_product_container').each(function(){
      $(this).addClass('subscription_product_container--hidden');
      if(productSubscription == $(this).data('product') ){
      	$(this).removeClass('subscription_product_container--hidden');
        $(this).find('#Subscription__submit').attr('data-order-form', 'false');
        $('.subscription__summary').removeClass('subscription__summary--hidden');
        $('.subscription__summary_extra').removeClass('subscription__summary--hidden');
        $(this).find('.subsciption__interval-inline').removeClass('subscription__summary--hidden');
        $("html, body").animate({
          scrollTop: $(this).find('.subsciption__interval_first').offset().top - 80
        }, 500);
      }
    });
  })

  
  /* ----------------------------------------------------
  open/close exotic function
  -----------------------------------------------------*/
  selectors.$exoticBlockTrigger.on('click',function(event){
    selectors.$exoticBlock.addClass('subsciption__product-list--exotic-block-active');
    $('.subscription_product_container').each(function(){
      $(this).addClass('subscription_product_container--hidden');
      $('#Subscription__submit').attr('data-order-form', 'true');
      
      $('.subscription__summary').addClass('subscription__summary--hidden');
      $('.subscription__summary_extra').addClass('subscription__summary--hidden');
     $('.subsciption__interval-inline').addClass('subscription__summary--hidden');
      slide('#subscription__exotic-block');

    });
    
  })

  selectors.$exoticBlockClose.on('click',function(event){
    selectors.$exoticBlock.removeClass('subsciption__product-list--exotic-block-active');
    var productSubscription = $(this).data('product');
    $('.subscription_product_container').each(function(){
      $(this).addClass('subscription_product_container--hidden');
      if(productSubscription == $(this).data('product') ){
      	$(this).removeClass('subscription_product_container--hidden');
        $(this).find('#Subscription__submit').attr('data-order-form', 'false');
        $('.subscription__summary').removeClass('subscription__summary--hidden');
        $('.subscription__summary_extra').removeClass('subscription__summary--hidden');
        $(this).find('.subsciption__interval-inline').removeClass('subscription__summary--hidden');
        $("html, body").animate({
          scrollTop: $(this).find('.subsciption__interval_first').offset().top - 80
        }, 500);
      }
    });
  })

  
  
  function slide(elm){
    $("html, body").animate({
      scrollTop: $(elm).offset().top - 80
    }, 500)
  }



  /* ----------------------------------------------------
  mirror functions
  -----------------------------------------------------*/

  selectors.$product.on('click', function(event){

    event.preventDefault ? event.preventDefault() : (event.returnValue = false);    
    
    $this = $(this),
    title = $this.attr('data-subscription-title'),
    price = $this.attr('data-subscription-price');
    available = $this.attr('data-subscription-available');

    if ($this.hasClass('subsciption__product--no-click')) {
      return false;
    }

    if($this.hasClass('subscription__product--house')){
      $('.subscription__summary').removeClass('subscription__summary--hidden');
      slide('.subscription__summary');
    }
    
    selectors.$submit.html("Order Now")
    selectors.$submit.attr( "disabled", false )
    if(available == "false"){
      selectors.$submit.html("Sold out")
    selectors.$submit.attr( "disabled", true )
    }    
    
    selectors.$product.removeClass(selectors.activeClass);
    $this.addClass(selectors.activeClass);

    priceUpdate(price);
    selectors.$productMirror.html(title);
  });


  selectors.$interval.on('change', function(event){
    event.preventDefault ? event.preventDefault() : (event.returnValue = false);
    $this = $(this),
    selectors.interval = $this.val();
    selectors.$intervalMirror.html($this.val());
  });


  function priceUpdate(x){
    var itemPrice   = x; // cents
    var priceFormatted = slate.Currency.formatMoney(itemPrice, theme.moneyFormat);
    selectors.$price.html(priceFormatted + ' per delivery');
  }

  /* ----------------------------------------------------
  Product data updates
  -----------------------------------------------------*/

  selectors.$quantity.on('change', function(event){
    event.preventDefault ? event.preventDefault() : (event.returnValue = false);    
    $this = $(this),
    dropQuantity = $this.val();
    $this.closest('.subsciption__product').attr('data-subscription-quantity', dropQuantity)
    // selectors.$quantityMirror.html(numberInText($this.val()));
  });



  // selectors.$quantityMirror.html(numberInText(1));

  function numberInText(x){
    var x = parseInt(x); 
    switch(x) {
      case 1:
          number = 'One';
          break;
      case 2:
          number = 'Two';
          break;
      case 3:
          number = 'Three';
          break;
      case 4:
          number = 'Four';
          break;
      case 5:
          number = 'Five';
          break;
      case 6:
          number = 'Six';
          break;
      case 7:
          number = 'Seven';
          break;
      case 8:
          number = 'Eight';
          break;
      case 9:
          number = 'Nine';
          break;
      default:
          number = x;
    }
    return number;
  }


  function subscriptionValidate(){

    selectors.$error.addClass('error--hide');

    if ($('#Subscription__submit').attr('data-order-form') == 'true'){


      // var orderloopProd = $('#subscription__house-block .subsciption__product'),
      //     subCounter    = 0;

      // $.each(orderloopProd, function(i, item){
      //   subCounter = subCounter + parseInt($(item).attr('data-subscription-quantity'))
      // });

      // console.log(subCounter);
      // if (subCounter < 4) {
      //   selectors.$error.html('Please select 4 or more product House Coffees').removeClass('error--hide');
      // } else {
      //   $.each(orderloopProd, function(i, item){
      //     dataLoop($(item));
      //   });
      // }

    } else{
      // dataLoop($(item));
    }

    dataLoop($('.subsciption__product--active'));

  }

  function dataLoop($this){
    data = {
      "quantity": $this.attr('data-subscription-quantity'),
      "id": $this.attr('data-subscription-id'),
      "properties[shipping_interval_frequency]": selectors.interval,
      "properties[shipping_interval_unit_type]": 'Weeks',
      "properties[subscription_id]": $this.attr('data-subscription-sub-id')
    }
    
    theme.AjaxCart.addToCart(data, selectors.$error)

  }

 




  // Normal subscription page
//   $('.js-rc-popup--open').on('click', function(){
//     $('.product-meta').addClass('rc_container--active');
//     $('.rc_label__autodeliver').trigger('click');
//     $('#main-form').attr("data-sub","sub")
//   });

//   $('.js-rc-popup--close').on('click', function(){
//     $('.product-meta').removeClass('rc_container--active');
//     $('.rc_label__onetime').trigger('click');
//     $('#main-form').attr("data-sub","no-sub");
//   });

})();
theme.SlideTo = (function() {

	////////// Scroll to //////////////
  $(".slide-to").click(function(ev) {
      ev.preventDefault();

      var slideLink = $(this).attr("href");
      $('.slide-to').children().find('.mini-nav__link__strike').removeClass('active');
      $(this).children().find('.mini-nav__link__strike').addClass('mini-nav__link__strike--active');
      $("html, body").animate({
        scrollTop: $(slideLink).offset().top - 100
      }, 1000)

    });

})();



theme.Cart = (function() {

  var $checkout = $('#cart-checkout');

  if (!$checkout.length) {
    return;
  }

  /*
  function getCartJSON(callback, x, y) {
    jQuery.getJSON('/cart.js', function (cart) {
      callback(cart, x, y);
    });
  };

  
  function coffeeCounter(cartData){
    var cart            = cartData,
        cartItems       = cart.items,
        cartLength      = cart.items.length,
        coffeeCount     = 0;

    $.each(cartItems, function(i, item){
      var itemval = item.variant_title;
      console.log(item);
      if(item.product_type != 'Gift Card'){
        if(itemval != null && itemval != 10){
          var itemCount = parseInt((itemval/10)*(item.quantity)),
              loopPos   = i + 1;
        }else{
          var itemCount = parseInt(item.quantity),
              loopPos   = i + 1;
        }
		coffeeCount = coffeeCount + itemCount;
        
        if (cartLength == loopPos) {

          if ( (coffeeCount == 3 || coffeeCount == 5 || coffeeCount == 7 || coffeeCount > 8) && coffeeCount != 16 ){
            hideCheckout();
            return false;
          }else{
            showCheckout();
            return false;
          }
        }
      }

    });
  }
  */
  

  function showCheckout(){
    $checkout.prop("disabled", false);
  }


  //getCartJSON(coffeeCounter);
  
  function validateAmount(){
  	var coffeeCount = 0;
    
    $('input[name="updates[]"]').each(function(){
      var qty = parseInt($(this).val());
      var variantTitle = parseInt($(this).data('variant-title'));
      var variantQty = parseInt($(this).data('variant-qty'));
      var quantity = qty * variantQty; 
      
      coffeeCount = coffeeCount + quantity;

    });
    if ( coffeeCount % 2 == 0 ){
      showCheckout();
      return true;
    }else{
      hideCheckout();
      return false;
    }
  }
  
  $('#cartcheck').click(function(){
    if( validateAmount() ){
        
      if ($('input#gift-wrapping').prop('checked')) {
        //check if there is a gift note (compulsory if you added a gift card)
        if ($("#gift-note").val() == ''){
          $('.req').addClass('show');
          $('#gift-note').addClass('red-border');
          $([document.documentElement, document.body]).animate({
            scrollTop: $("#is-a-gift").offset().top - $('#Header').height()
          }, 2000);
        }
        else{
          $('.req').removeClass('show');
          $('#gift-note').removeClass('red-border');          
          //console.log('now you can trigger');
          $('#cart-checkout').trigger('click');
        }
      } else {
        $('#cart-checkout').trigger('click');	    
      }
    }
  });
  
  validateAmount()
 
})();
theme.Faq = (function() {
    var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  // resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    //toggleRecoverPasswordForm();
  }
  
    /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('.login_wrapper').toggleClass('hide');
    $('.recover_wrapper').toggleClass('hide');
  }



  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
       toggleRecoverPasswordForm();
    }
    

  }



})();
theme.Custom = (function() {
  // make meet the brands links open in new tab
  $('#shopify-section-1540387082253 .blog-grid-item__container a').attr('target','_blank');
  // add footer contact us link
//   $( "<p style='margin-top:0'>Contact Us: <a href='mailto:hello@halo.coffee'>hello@halo.coffee</a></p><p>Business Enquiries:<br>+44 207 935 4012</p>" ).insertBefore( "footer ul.social-links" );
  // click Shop on product page to return to collection
  $('body.template-product .mini-nav h4').click(function(){window.location='/collections/coffee'});

  $('.grid__item--match-height').matchHeight(); 
  /*
     $('div[data-quantity]').click(function(){
    var quantity = $(this).attr('data-quantity');
    $('select[name="quantity"]').val(quantity).change();
    $('div[data-quantity]').removeClass('selected');
    $(this).addClass('selected');
    
    if($('#radio-2').is(':checked')) {
    var pricehtml = $('#rc_price_autodeliver').html();
      if( pricehtml.charAt( 0 ) === '£' ){
       pricehtml = pricehtml.slice( 1 );
      }
      var newprice = (quantity*pricehtml).toFixed(2);
      //$('.capsule_price .h3').html('<span class="per_span">per delivery</span> £'+newprice);
      
      
    }   
    else{  
    var variant_price = $(this).parent().attr('data-variant-price');
    var capsule_price = '£' + ((variant_price * quantity) / 100 ).toFixed(2);
    $('.capsule_price .h3').html(capsule_price);
   }   
  })
     */
  $('div[data-quantity1]').click(function(){
    var quantity = $(this).attr('data-quantity1');
    $('select[name="quantity"]').val(quantity).change();
    $('div[data-quantity1]').removeClass('selected');
    $(this).addClass('selected');

    var variant_price = $(this).parent().attr('data-variant-price');
    var capsule_price = '£' + ((variant_price * quantity) / 100 ).toFixed(2);
    $('.capsule_price .h3').html(capsule_price);

  });
    
  
})();



/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });
 
  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('.login_wrapper').toggleClass('hide');
    $('.recover_wrapper').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

this.reorder = new function(){
  var self = this;

  this.pushQueue = function(i, data, el){

    //LOW STOCK -- add as many as possible if stock is below requested ammount
    if(data[i].check_inventory){
      data[i].quantity = Math.min(parseInt(data[i].inventory), parseInt(data[i].quantity));
    }
    console.log(data[i].properties.replace(/;/g,','));
    var thisProperties = "";
    if(data[i].properties){
      thisProperties = data[i].properties.toString();
      thisProperties = JSON.parse(thisProperties.replace(/;/g,','));
    }
    console.log('thisProperties:'+thisProperties);
    $.ajax({
      url: '/cart/add.js',
      method: 'POST',
      data: {
        quantity: data[i].quantity,
        id: data[i].id,
        properties: thisProperties
      },
      complete: function(res){
        if(i >= data.length - 1){
          //products from queue are now added to the cart -> stop loading signal and go to cart
          el.removeClass('loading');
          window.location.href = '/cart';
          return;
        }else{
          // Calls are async as required by Shopify Docs
          self.pushQueue(i+1, data, el);
        }
      }
    });
  }

  this.listen = function(){
    var el = $(this);
    var ids = el.attr('data-variant-ids').split(',');
    var quantities = el.attr('data-variant-quantities').split(',');
    var inventories = el.attr('data-variant-inventories').split(',');
    var inventory_policies = el.attr('data-variant-inventory-policies').split(',');
    var inventory_trackers = el.attr('data-variant-inventory-trackers').split(',');
    var properties = el.attr('data-properties').split(',');
    
    ids.splice(-1, 1);
    quantities.splice(-1, 1);
    inventories.splice(-1, 1);
    inventory_policies.splice(-1, 1);
    inventory_trackers.splice(-1, 1);
    properties.splice(-1, 1);

    var data = [];
    for(var i=0; i<ids.length; i++){
      data.push({
        id: ids[i],
        quantity: quantities[i],
        inventory: inventories[i],
        check_inventory: (inventory_policies[i] == "deny" && inventory_trackers[i] != ""),
        properties: properties[i]
      });
    }
    el.addClass('loading');
    self.pushQueue(0, data, el);
  }

  this.init = function(){
    $('.reorder-btn').on('click', self.listen);
  }
}
$(reorder.init);



$(document).ready( function(){
  $('.create').click(function() {
    $('.login__left').addClass('hide');
    $('.login__right').removeClass('hide');
  })
});

$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);
  sections.register('slideshow', theme.SlideshowSection);
  sections.register('notification-bar', theme.NotificationBarSection);
  sections.register('meganav', theme.MeganavSection);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  $("select.style-select").selectOrDie();
});


$(document).ready(function(){
	$(".account-sidebar li").hover(function(){
		$(this).toggleClass("acc-actv");
	});
  
});

$(document).ready(function(){
  //Blog page scripts
  $(".account-sidebar li").hover(function(){
    $(this).toggleClass("acc-actv");
  });

  //Init
  $.js = function (el) {
    return $('[data-js=' + el + ']')
  };

  function chosen() {
    $(".chosen-select").chosen({
      disable_search_threshold: 100,
      inherit_select_classes: true,
      width: '100%'
    }).on('chosen:showing_dropdown', function (evt, params) {
      $(this).parent().addClass('is-active');
      $.js('custom-scroll').find(".chosen-results").niceScroll({
        cursorcolor:"#000",
        cursorwidth:"10px",
        background:"#eeeeee",
        cursorborder:"1px solid #eeeeee",
        cursorborderradius:0,
        cursoropacitymin:1,
        cursorfixedheight: 30
      });
    }).on('chosen:hiding_dropdown', function (evt, params) {
      $(this).parent().removeClass('is-active');
    });
  }

  chosen();

  lazyload();
  
});

$(window).load(function () {
  $(window).scroll(function() {
    // if no cookie
    if ($.cookie('popup') != "true") {
      if ($(window).scrollTop() >= ($(document).height() - $(window).height())) {
        $('.NewsletterPopup').css({"transform": "translateY(0)", "opacity": "1", "visibility" : "visible"}).show();

      }

      $('.NewsletterPopup__Close').click(function(){
        $('.NewsletterPopup').css({"transform": "translateY(0)","opacity": "0", "visibility" : "hidden"}).hide();
        // set the cookie for 24 hours
        var date = new Date();
        //       date.setTime(date.getTime() + 24 * 60 * 60 * 1000);
        date.setTime(date.getTime() + 3600000*24*14);
        $.cookie('popup', "true", {
          expires: date
        });
      });
    }
  });
  lazyload();
});

(function(){
  $('.press-logos .grid__item').matchHeight();
})();



